import { useTranslation } from "react-i18next"
import { useGetHasReadMutation } from "store/apis/infoModalsAPI"
import { INFO_MODAL_TYPE } from "store/apis/infoModalsAPI/types"
import { useModal } from "context/ModalsContext"
import { getModalLang } from "utils/getModalLang"

export const useCheckNews = () => {
  const { openModal } = useModal()
  const { i18n } = useTranslation()

  const [getHasReadMutation] = useGetHasReadMutation()

  const checkNewsFeed = async () => {
    const hasReadNewsFeed = await getHasReadMutation({
      type: INFO_MODAL_TYPE.NEWS_FEED,
      lang: getModalLang(i18n.language)
    })
    if (!hasReadNewsFeed.data) {
      openModal({ type: "newsFeed" })
    }
  }

  // const checkMineFeed = async () => {
  //   const hasReadNewsMine = await getHasReadMutation({
  //     type: INFO_MODAL_TYPE.NEWS_MINE,
  //     lang: localStorageLanguage,
  //   })
  //   if (!hasReadNewsMine.data) {
  //     openModal({ type: "newsMine" })
  //   }
  // }

  const checkNews = async () => {
    checkNewsFeed()
    // checkMineFeed()
  }

  return checkNews
}
